export default "__VITE_ASSET__CC$Up6_X__"